import '@/shared-components/inputs/components/styles/PublicFormInput.scss';
import './styles/ShippingNameInput.css';

export default function ShippingNameInput({ value, onChange, placeholder, className = '' }) {
  return (
    <input
      type="text"
      className={`public-form-input__input shipping-name-input ${className}`.trim()}
      autoComplete="off"
      spellCheck={false}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
}
